import ApplicationController from './application_controller'

// Client-side real-time filtering of the public catalog lots.
// A query matches when it equals the lot number exactly (`data-lot-number`, which
// can be alphanumeric like "158 bis"). Non-numeric queries additionally do a
// substring search over the lot text (`data-search`: name + description). Purely
// numeric queries stay out of that text search, so digits in descriptions
// (dimensions, years, edition numbers) never pollute a lot-number lookup.
export default class extends ApplicationController {
  static targets = ['input', 'lot', 'counter']

  filter () {
    const query = this.inputTarget.value.trim().toLowerCase()
    const numeric = /^\d+$/.test(query)
    let shown = 0

    this.lotTargets.forEach((lot) => {
      const match = query === '' ||
        lot.dataset.lotNumber.toLowerCase() === query ||
        (!numeric && lot.dataset.search.includes(query))
      // Inline style, not the `hidden` attribute: the card's Tailwind `flex`
      // utility would otherwise override `[hidden] { display: none }`.
      lot.style.display = match ? '' : 'none'
      if (match) shown++
    })

    this.counterTarget.textContent = shown
  }
}
